<template>
    <h-disclosure v-slot="{ open }"
        as="div"
        class="group">
        <v-disclosure-button class="flex w-full items-center space-x-md p-md text-left outline-none">
            <span class=" flex flex-1 items-center justify-between text-sm tracking-xl">
                <span class="w-40 group-focus-within:underline group-hover:underline">
                    {{ method.title }}
                </span>

                <div class="order-1 flex flex-col items-end space-x-2 space-y-1 text-xs font-bold md:order-2">
                    <strong v-if="method.originalPriceWithServices
                                && Number(method.originalPriceWithServices.amount) !== 0"
                        :class="{
                            'text-gray-500 line-through': isFreeShipping
                                || method.priceWithServices.amount !== method.originalPriceWithServices.amount,
                        }">
                        {{ formatCurrency(method.originalPriceWithServices.amount, { maximumFractionDigits: 2 }) }}
                    </strong>

                    <strong v-if="!isFreeShipping
                        && Number(method.originalPriceWithServices.amount) === 0">
                        {{ formatCurrency(method.originalPriceWithServices.amount, { maximumFractionDigits: 2 }) }}
                    </strong>

                    <strong v-else-if="isFreeShipping && method.freeShippingPriceWithServices">
                        {{ formatCurrency(
                            method.freeShippingPriceWithServices.amount,
                            { maximumFractionDigits: 2 },
                        ) }}
                    </strong>

                    <strong v-else-if="method.priceWithServices.amount !== method.originalPriceWithServices.amount">
                        {{ formatCurrency(method.priceWithServices.amount, { maximumFractionDigits: 2 }) }}
                    </strong>
                </div>
            </span>

            <template v-if="method.description && method.description.length > 0">
                <v-icon v-if="open"
                    icon="minus"
                    class="text-xl"></v-icon>

                <v-icon v-else
                    icon="add"
                    class="text-xl"></v-icon>
            </template>
        </v-disclosure-button>

        <transition
            enter-active-class="transition duration-100 ease-out"
            enter-from-class="scale-95 opacity-0"
            enter-to-class="scale-100 opacity-100"
            leave-active-class="transition duration-75 ease-in"
            leave-from-class="scale-100 opacity-100"
            leave-to-class="scale-95 opacity-0"
        >
            <v-disclosure-panel v-if="method.description && method.description.length > 0"
                class="prose mx-md pb-sm text-sm text-gray-800 lg:px-md">
                <v-markdown :content="method.description" />
            </v-disclosure-panel>
        </transition>
    </h-disclosure>
</template>

<script setup lang="ts">
import type { ViewProductShippingMethodsQuery } from '~/graphql';

type Product = Extract<ViewProductShippingMethodsQuery['product'], { __typename: 'SimpleProduct' }>;

defineProps<{
    method: Product['availableShippingMethods'][0]
    isFreeShipping: boolean
}>();

const { format: formatCurrency } = useCurrency();
</script>
